import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  filter,
  map
} from 'rxjs/operators';
import {
  B2BUser,
  EntitiesModel,
  PaginationModel
} from '@spartacus/core';
import { TableService } from '@spartacus/storefront';
import {
  ListService,
  OrganizationTableType,
  UserModel
} from '@spartacus/organization/administration/components';
import { UigB2BUserService } from '../uig-b2b-user/uig-b2b-user.service';
import { UigOrganizationTableType } from '../../uig-organization.model';

@Injectable({
  providedIn: 'root',
})
export abstract class UigUserListService extends ListService<UserModel> {
  protected uigTableType: UigOrganizationTableType.UIG_USER;
  protected tableType = OrganizationTableType.USER;
  protected _domainType = 'orgUser';

  constructor(
    protected tableService: TableService,
    protected userService: UigB2BUserService
  ) {
    super(tableService);
  }

  public key(): string {
    return 'uid';
  }

  protected load(
    pagination: PaginationModel
  ): Observable<EntitiesModel<UserModel>> {
    return this.userService.getList(pagination).pipe(
      filter((list) => Boolean(list)),
      map((raw) => this.convertUsers(raw))
    );
  }

  /**
   * Populates the cost center data to a convenient table data model, so that we
   * can skip specific conversion in the view logic where possible.
   */
  protected convertUsers({
    pagination,
    sorts,
    values,
  }: EntitiesModel<B2BUser>): EntitiesModel<UserModel> {
    const userModels: EntitiesModel<UserModel> = {
      pagination,
      sorts,
      values: values.map((value: any) => ({
        ...value,
        unit: value.orgUnit,
      })),
    };
    return userModels;
  }
}
